/**
 * Tool-specific icon components for flow visualization
 */

import { Search, Database, Globe, Map } from 'lucide-react';
import React from 'react';

export type ToolIconProps = {
  size?: number;
  color?: string;
};

export const WebSearchIcon: React.FC<ToolIconProps> = ({ size = 16, color = '#0ea5e9' }) => (
  <Search size={size} color={color} />
);

export const MemoryLookupIcon: React.FC<ToolIconProps> = ({ size = 16, color = '#8b5cf6' }) => (
  <Database size={size} color={color} />
);

export const WebExtractIcon: React.FC<ToolIconProps> = ({ size = 16, color = '#10b981' }) => (
  <Globe size={size} color={color} />
);

export const WebMapIcon: React.FC<ToolIconProps> = ({ size = 16, color = '#f59e0b' }) => (
  <Map size={size} color={color} />
);

/**
 * Get icon component for a tool by name
 */
export function getToolIcon(toolName: string): React.FC<ToolIconProps> {
  const name = (toolName || '').toLowerCase();
  if (name.includes('search') && name.includes('memor')) {
    return MemoryLookupIcon;
  }
  if (name.includes('search')) {
    return WebSearchIcon;
  }
  if (name.includes('extract')) {
    return WebExtractIcon;
  }
  if (name.includes('map')) {
    return WebMapIcon;
  }
  // Default to search icon
  return WebSearchIcon;
}

/**
 * Get human-readable tool name
 */
export function getToolDisplayName(toolName: string): string {
  const name = (toolName || '').toLowerCase();
  if (name.includes('search') && name.includes('memor')) {
    return 'Memory Lookup';
  }
  if (name === 'web_search') {
    return 'Web Search';
  }
  if (name === 'web_extract') {
    return 'Web Extract';
  }
  if (name === 'web_map') {
    return 'Web Map';
  }
  // Fallback: capitalize and replace underscores
  return toolName
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
